import React from 'react';
import {
    TableCell,
    TableHead,
    TableRow
} from 'material-ui/Table';

const TableUserPermissionsHeader = ({
    groupedPermissions,
    classes
}) => {
    return (
        <TableHead>
            <TableRow className={classes.userPermsTableHeader}>
                {groupedPermissions.map(groupedPerm =>
                    <TableCell className={classes.userPermsTableCell} key={groupedPerm.id}>
                           Permissions Group for {groupedPerm.group_name}
                    </TableCell>
                )}
            </TableRow>
        </TableHead>
    )
}
export default TableUserPermissionsHeader;


// WEBPACK FOOTER //
// ./src/containers/users/forms/TableUserPermissionsHeader.jsx